import type { JourneyRuntime, StageRuntime, StageState } from '@cyberscore/contracts';
import { CheckCircle2, Circle, CircleDot, CircleSlash, Lock } from 'lucide-react';

export const STAGE_LABEL: Record<StageState, string> = {
  locked: 'Locked',
  available: 'Ready',
  active: 'In progress',
  completed: 'Done',
  skipped: 'Not needed',
};

export function StageIcon({ state, size = 18 }: { state: StageState; size?: number }) {
  const Icon = {
    locked: Lock,
    available: Circle,
    active: CircleDot,
    completed: CheckCircle2,
    skipped: CircleSlash,
  }[state];
  return <Icon size={size} className={`stage-icon ${state}`} aria-hidden="true" />;
}

/** Why a stage is locked or skipped, in words: "Opens once Digital footprint and Data are done." */
export function stageNote(s: StageRuntime, j: JourneyRuntime): string {
  const name = (key: string) => j.stages.find((x) => x.key === key)?.name ?? key;
  const list = (xs: string[]) =>
    xs.length > 1 ? `${xs.slice(0, -1).join(', ')} and ${xs.at(-1)}` : (xs[0] ?? '');
  if (s.state === 'skipped')
    return s.routed_by ? `Skipped: ${s.routed_by.label}.` : 'Does not apply, given your earlier answers.';
  if (s.state !== 'locked') return '';
  if (s.waiting_for.length) {
    const started = s.waiting_for.filter((p) => p.when === 'started').map((p) => name(p.stage));
    const done = s.waiting_for.filter((p) => p.when === 'completed').map((p) => name(p.stage));
    return (
      [
        done.length && `Opens once ${list(done)} ${done.length > 1 ? 'are' : 'is'} done`,
        started.length &&
          `${done.length ? 'and' : 'Opens once'} ${list(started)} ${started.length > 1 ? 'have' : 'has'} started`,
      ]
        .filter(Boolean)
        .join(' ') + '.'
    );
  }
  return 'Opens depending on an earlier answer.';
}
